module.exports = __webpack_public_path__ + "img/8.08afaad0.svg";